<template>
  <div class="tickets-list__heading">
    <div class="tickets-list__heading__left">
      <div
        v-if="!searchMode"
        class="tickets-tabs"
      >
        <template
          v-for="tab in tabs"
        >
          <div
            :key="tab.id"
            class="tickets-tabs__tab"
            :class="{
              'is--active': active === tab.id,
              'is--disabled': tab.denyAccess.includes($store.user.role_id)
            }"
            @click="changeTab(tab.id, tab.denyAccess.includes($store.user.role_id))"
            v-if="tab.title"
          >
            <i :class="tab.icon" />
            <span class="text">{{ tab.title | translate }}</span>
            <span
              v-if="tab.count"
              class="count"
            >{{ tab.count }}</span>
          </div>
        </template>
      </div>
      <TicketsSearch
        v-else
        @change="search"
      />
    </div>
    <div class="tickets-list__heading__right">
      <div class="tickets-list__heading__right__back">
        <i class="ri-arrow-left-line" @click="mobileClose" />
      </div>
      <div class="tickets-list__heading__right__title">
        {{ 'd_ws_tab_queue' | translate }}
      </div>
      <span
        v-if="!searchMode"
        class="search-open"
        @click="openSearch"
      >
        <i class="ri-search-line" />
      </span>
      <span
        v-else
        class="search-close"
        @click="closeSearch"
      >
        <i class="ri-close-fill" />
      </span>
    </div>
  </div>
</template>

<script>

import TicketsSearch from "./TicketsSearch";
  
export default {
  components: {
    TicketsSearch
  },
  props: ['tabs', 'active'],
  data() {
    return {
      searchMode: false
    }
  },
  methods: {
    changeTab(id, disabled) {
      if (!disabled) {
        this.$emit('changeTab', id);
      }
    },
    openSearch() {
      this.searchMode = true;
      this.$emit('searchOpen')
    },
    closeSearch() {
      this.searchMode = false;
      this.$emit('searchClose')
    },
    search(searchString) {
      this.$emit('searchChange', searchString)
    },
    mobileClose() {
      if (this.searchMode) this.closeSearch();
      else this.$emit('mobileClose')
    }
  }
}
</script>

<style lang="scss" scoped>
  .tickets-list {
    &__heading {
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      &__left {
        width: 100%;
        .tickets-tabs {
          display: flex;
          align-items: center;
          &__tab {
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: 30px;
            cursor: pointer;
            color: var(--label-secondary);
            text-transform: uppercase;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: .5px;
            border: 1px solid transparent;
            i {
              font-size: 20px;
              margin-right: 4px;
              vertical-align: middle;
            }
            span.count {
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 16px;
              height: 16px;
              font-size: 12px;
              margin-left: 4px;
              color: var(--light-01);
              background-color: var(--label-secondary);
              border-radius: 21px;
              font-weight: normal;
              padding: 0 4px;
            }
            &.is--active {
              border-color: var(--accent-blue);
              color: var(--accent-blue);
              cursor: default;
              span.count {
                background-color: var(--accent-blue);
              }
            }
            &.is--disabled {
              cursor: not-allowed;
              color: var(--label-tetriary);
            }
          }
        }
      }
      &__right {
        margin-left: auto;
        span {
          cursor: pointer;
          margin-left: 8px;
          &.search-close {
            i {
              color: var(--label-primary);
            }
          }
          i {
            font-size: 24px;
            color: var(--label-secondary);
          }
        }
        &__back,
        &__title {
          display: none;
        }
        &__back {
          i {
            font-size: 24px;
            vertical-align: middle;
          }
        }
        &__title {
          color: var(--accent-blue);
          font-weight: 500;
          font-size: 16px;
          text-transform: uppercase;
        }
      }
    }
  }

  @media (max-width: 425px) {
    .tickets-tabs {
      padding: 3px 6px 7px 6px;
      &__tab {
        width: 100%;
        justify-content: center;
        padding: 8px 10px !important;
        i {
          margin-right: 0 !important;
        }
        span.text {
          display: none;
        }
      }
    }
    .tickets-list {
      &__heading {
        display: flex;
        flex-direction: column;
        flex-flow: wrap;
        position: relative;
        margin-bottom: 0;
        border-bottom: 1px solid var(--light-02);
        &__left {
          order: 1;
        }
        &__right {
          order: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding: 12px;
          height: 48px;
          &__back,
          &__title {
            display: block;
          }
        }
      }
    }
  }
</style>
